import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react';
import tinycolor from 'tinycolor2';
import { otherColor, patternPalette } from './palette';

/**
 * Colours of the analyst's patterns: the highlighter colours of Figure 2 in a fixed order (see palette.ts), so a
 * pattern keeps its colour. Beyond them, colours fold into one neutral grey; the labels (A, B, ...) keep them apart.
 * Operator variants (A', A'') take a shade of their pattern's colour (usePatterns).
 */
export const otherPatternColor = otherColor;
// `availablePatternColors` is used as a stack (pop): the first palette slot sits at the end.
const patternColors = [...Array(500).fill(otherPatternColor), ...[...patternPalette].reverse()];
export const voiceColors = [
  '#fd7f6f',
  '#7eb0d5',
  '#b2e061',
  '#bd7ebe',
  '#ffb55a',
  '#ffee65',
  '#e5d8bd',
  '#beb9db',
  '#fdcce5',
  '#8bd3c7'
];

interface Theme {
  availablePatternColors: string[];
  colorByVoice: boolean;
  colorVoices: boolean;
  getVoiceColor: (voiceNumber: number) => string | undefined;
}

const defaultTheme = {
  availablePatternColors: patternColors.map((color) => tinycolor(color).toHexString()),
  colorByVoice: false,
  colorVoices: false,
  getVoiceColor: (voiceNumber: number) =>
    voiceNumber <= voiceColors.length ? voiceColors[voiceNumber - 1] : undefined
};

export const ThemeContext = createContext<[Theme, Dispatch<SetStateAction<Theme>>]>([
  defaultTheme,
  undefined
]);

const ThemeContextProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState(defaultTheme);

  return <ThemeContext.Provider value={[theme, setTheme]}>{children}</ThemeContext.Provider>;
};

export default ThemeContextProvider;
